import { defineMessages } from 'react-intl';

import { BillingProductBlockReason } from '@/entities/organization';

import { AddSubscriptionBlockReason } from './types';

// The scheduledExists and autoRenewal ids are the ones this widget already
// shipped, kept so their existing en-US/ru translations stay valid.
export const addSubscriptionBlockReasonMessages =
  defineMessages<AddSubscriptionBlockReason>({
    accountLoading: {
      id: 'currentSubscription.addLoadingTooltip',
      defaultMessage: 'Billing data is still loading.',
    },
    noPermission: {
      id: 'currentSubscription.addNoPermissionTooltip',
      defaultMessage: 'You do not have permission to create billing orders.',
    },
    scheduledExists: {
      id: 'currentSubscription.addScheduledTooltip',
      defaultMessage:
        'Remove the scheduled subscription before adding another one.',
    },
    autoRenewal: {
      id: 'currentSubscription.addTooltip',
      defaultMessage:
        'Turn off auto-renew for the current subscription to schedule the next subscription.',
    },
  });

export const manageSubscriptionBlockReasonMessages =
  defineMessages<BillingProductBlockReason>({
    noPermission: {
      id: 'currentSubscription.manageNoPermissionTooltip',
      defaultMessage: 'You do not have permission to modify a subscription.',
    },
  });
